var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgChurch(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "https://www.w3.org/2000/svg",
    xmlnsXlink: "https://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 310 310",
    style: {
      enableBackground: "new 0 0 30 310"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "253.381,206.25 253.381,299.157 253.381,299.465 310,299.465 310,238.977",
    fill: "#3F51B5"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "0,299.465 56.619,299.465 56.619,299.157 56.619,206.178 0,238.977",
    fill: "#3F51B5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.619,174.559v124.598h58.047v-52.825c0-16.568,13.432-30,30-30h0.668c16.568,0,30,13.432,30,30v52.825h58.047V174.559 L155,101.247L66.619,174.559z",
    fill: "#3F51B5"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "27.502,161.587 42.498,179.785 155,87.083 267.502,179.785 282.498,161.587 162,62.297 162,40.202 183.631,40.202  183.631,26.202 162,26.202 162,10.535 148,10.535 148,26.202 126.369,26.202 126.369,40.202 148,40.202 148,62.297",
    fill: "#3F51B5"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChurch);
export default __webpack_public_path__ + "static/media/church.ec8084f33b3454dabe31b09dac51d95c.svg";
export { ForwardRef as ReactComponent };